var map = {
	"./cash-register-reports/index.js": 950,
	"./dashboard/index.js": 957,
	"./orders/index.js": 964,
	"./sales/index.js": 967,
	"./stock-entry-reports/index.js": 974,
	"./xmls/index.js": 977
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2734;


//////////////////
// WEBPACK FOOTER
// ./src/components/app/history \.\/[^\/]+\/index\.jsx?$
// module id = 2734
// module chunks = 0